import { Box } from "@mui/material";
import DataGridComponent from "../components/datagrid/datagrid.component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getRouterPaths } from "../router/routerPaths";
import { useIsMobile } from "../hook/useIsMobile";
import { useCallback, useEffect, useRef, useState } from "react";
import { fetchIrrigationTypesStart } from "../store/features/irrigationTypes/irrigationTypesSlice";
import {
  createIrrigationColumns,
  createIrrigationRowsData,
  getIrrigationActions,
} from "../config/tables/irrigationTable.config";
import CustomDialog from "../components/muiDialogs/dialog.component";
import { dialogMessages } from "../components/forms/utils";
import {
  deleteIrrigationTypeStart,
  resetCreateIrrigationTypeState,
  resetUpdateIrrigationTypeState,
} from "../store/features/irrigationType/irrigationTypeSlice";

const IrrigationTypePage = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchTimeoutRef = useRef();

  const type = useSelector((state) => state.me?.data?.data?.type);
  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const irrigationTypesData = useSelector(
    (state) => state.irrigationTypes?.data?.data
  );
  const isIrrigationTypesLoading = useSelector(
    (state) => state.irrigationTypes?.isLoading
  );
  const { success } = useSelector((state) => state.irrigationType);

  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedIrrigationType, setSelectedIrrigationType] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");

  const routerPaths = getRouterPaths(type);
  const rows = irrigationTypesData?.map(createIrrigationRowsData);

  const irrigationActions = getIrrigationActions({
    navigate,
    routerPaths,
    setSelectedIrrigationType,
    setSelectedAction,
    setDialogOpen,
  });

  const columns = createIrrigationColumns(irrigationActions);

  const handleSearchChange = useCallback((value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSearchQuery(value);
    }, 500);
  }, []);

  const handleDialogConfirm = () => {
    if (selectedIrrigationType) {
      dispatch(
        deleteIrrigationTypeStart({
          irrigationTypeId: selectedIrrigationType,
          accessToken,
        })
      );
      setDialogOpen(false);
      setSelectedIrrigationType(null);
      setSelectedAction("");
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedIrrigationType(null);
    setSelectedAction("");
  };

  useEffect(() => {
    if (type === "Admin") {
      dispatch(fetchIrrigationTypesStart({ accessToken, search: searchQuery }));
    }
  }, [dispatch, type, accessToken, searchQuery]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (success) {
      dispatch(resetCreateIrrigationTypeState());
      dispatch(resetUpdateIrrigationTypeState());
    }
  }, [dispatch, success]);

  return (
    <Box width="100%">
      <DataGridComponent
        rows={rows}
        columns={columns}
        inputPlaceholder="Cerca irrigazione"
        onSearchChange={handleSearchChange}
        marginTop={5}
        showButton
        buttonLabel={"Nuova irrigazione"}
        buttonHref={`/${type?.toLowerCase()}/irrigationType/addIrrigation`}
        isMobile={isMobile}
        loading={isIrrigationTypesLoading}
      />
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogConfirm}
        title={dialogMessages.irrigationType[selectedAction]?.title}
        description={dialogMessages.irrigationType[selectedAction]?.description}
        confirmLabel={
          dialogMessages.irrigationType[selectedAction]?.confirmLabel
        }
        actions={irrigationActions}
      />
    </Box>
  );
};

export default IrrigationTypePage;
